import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1311d106"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column h-full" }
const _hoisted_2 = { class: "mr-s2 caption" }
const _hoisted_3 = { class: "panel-frame panel-scrollable flex-grow-1" }
const _hoisted_4 = { class: "token-list-draggable gutter-y-s1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ordered-list-number text-primary" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "token-list gutter-y-s1 mt-s1"
}
const _hoisted_7 = {
  key: 1,
  class: "token-list gutter-y-s1 mt-s1"
}
const _hoisted_8 = {
  key: 2,
  class: "token-list-disabled mt-s1"
}
const _hoisted_9 = { class: "gutter-y-s1" }
const _hoisted_10 = {
  key: 0,
  class: "text-center text-muted text-sm"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-s1"
}
const _hoisted_12 = { class: "token-list-disabled gutter-y-s1" }

import { Nullable } from 'primevue/ts-helpers';
import { VueDraggableNext as draggable } from 'vue-draggable-next';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { TOKEN_NOTICE_TYPES } from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/common/constants/TOKEN_NOTICE_TYPES';
import {
  EasyModeAddLiquidityToken,
  EasyModeToken,
  EasyModeWithdrawToken,
} from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/models/easy-mode-token';
import Token from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/common/tokens-list/Token.vue';
import { PortfolioSource } from '@/sdk/entities/PortfolioSource';
import { compareTokens } from '@/sdk/utils';
import { moveItem } from '@/utils/array';
import {
  getPortfolioBlockedTokens,
  useEasyModeForm,
} from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/composables/useEasyModeForm';
import TokenUnavailable from '@/views/pages/liquidity/portfolios/portfolio/liquidity-management/easy-mode/common/tokens-list/TokenUnavailable.vue';
import { usePrevious } from '@/composables/usePrevious';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenList',
  props: {
    currentAction: null
  },
  setup(__props: any) {

const props = __props as { currentAction: string }

const { easyModeForm, forceDisabled, selectedTokens } = useEasyModeForm();



const { state } = useStore();

const triStateCheckboxValue = ref<boolean | null>(null);
const triStateCheckboxValuePrevious = usePrevious(triStateCheckboxValue);
const isCollapsed = ref(true);

const draggableTokensList = computed(() => {
  const draggableTokens = (selectedTokens.value as EasyModeToken[]).filter(
    token => token.draggable,
  );

  if (draggableTokens.length < 2) {
    return [];
  }
  return draggableTokens;
});

const draggableTokensListMutable = computed(() => draggableTokensList.value.slice());

const activeAndNotCheckedTokensList = computed(() =>
  (easyModeForm.tokens as EasyModeToken[]).filter(token => !token.checked && !token.disabled),
);
const checkedAndNotDraggableTokenList = computed(() => {
  if (draggableTokensList.value.length === 0) {
    return selectedTokens.value;
  }

  return (selectedTokens.value as EasyModeToken[]).filter(token => !token.draggable);
});

const disabledTokensList = computed(() =>
  (easyModeForm.tokens as EasyModeToken[]).filter(token => token.disabled && !token.checked),
);
const triStateCheckboxDisabled = computed(
  () =>
    (easyModeForm.tokens as EasyModeToken[]).every(token => token.disabled) || forceDisabled.value,
);
const unavailableTokensList = computed(() => {
  if (props.currentAction === 'addLiquidity') {
    return easyModeForm.portfolio.crossChainTokens;
  }

  // withdraw
  const portfolioTokens =
    easyModeForm.portfolio.type === PortfolioSource.PORTFOLIO_CROSSCHAIN
      ? easyModeForm.portfolio.tokens
      : [];

  return [...portfolioTokens, ...easyModeForm.portfolio.crossChainTokens].filter(
    tokenInfo => !tokenInfo.availableOn.includes(easyModeForm.destinationChainId.toString()),
  );
});

const blockedTokensList = computed(() => getPortfolioBlockedTokens(easyModeForm.portfolio));
const blockedTokenNoticeType = computed(() =>
  easyModeForm.action === 'addLiquidity'
    ? TOKEN_NOTICE_TYPES.SHARE_TOO_BIG
    : TOKEN_NOTICE_TYPES.SHARE_TOO_SMALL,
);

watch(easyModeForm, form => {
  if (forceDisabled.value) {
    return;
  }

  if (form.tokens.some(token => token.checked)) {
    if ((easyModeForm.tokens as EasyModeToken[]).every(token => token.checked || token.disabled)) {
      triStateCheckboxValue.value = true;
      return;
    }

    triStateCheckboxValue.value = false;
    return;
  }

  triStateCheckboxValue.value = null;
});

watch(forceDisabled, value => {
  if (value) {
    triStateCheckboxValue.value = null;
  }
});

const toggleCollapsed = () => {
  isCollapsed.value = !isCollapsed.value;
};

const onTriStateCheckBoxUpdated = (value: Nullable<boolean>) => {
  nextTick(() => {
    if (value) {
      return selectAllAvailable();
    }

    if (triStateCheckboxValuePrevious.value === false) {
      triStateCheckboxValue.value = true;
      return selectAllAvailable();
    }

    easyModeForm.tokens.forEach(token => {
      token.checked = false;
    });
  });
};

const onSetTokenOrder = (e: { moved: { oldIndex: number; newIndex: number } }) => {
  const draggedToken = draggableTokensList.value[e.moved.oldIndex];

  const oldIndexInAllSelectedTokensList = selectedTokens.value.findIndex(t =>
    compareTokens(t, draggedToken),
  );
  const draggableTokenAtNewPosition = draggableTokensList.value[e.moved.newIndex];
  const newIndexInAllSelectedTokensList = selectedTokens.value.findIndex(t =>
    compareTokens(t, draggableTokenAtNewPosition),
  );

  const newOrderSelectedTokens = moveItem(
    selectedTokens.value,
    oldIndexInAllSelectedTokensList,
    newIndexInAllSelectedTokensList,
  );

  const uncheckedTokens = (easyModeForm.tokens as EasyModeToken[]).filter(token => !token.checked);
  easyModeForm.tokens = newOrderSelectedTokens.concat(uncheckedTokens) as
    | EasyModeWithdrawToken[]
    | EasyModeAddLiquidityToken[];
};

function selectAllAvailable(): void {
  easyModeForm.tokens.forEach(token => {
    if (!token.disabled) {
      token.checked = true;
    }
  });
}

onMounted(() => console.log(easyModeForm));

return (_ctx: any,_cache: any) => {
  const _component_TriStateCheckbox = _resolveComponent("TriStateCheckbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["align-self-end flex align-items-center mt-s3 mb-s2 mr-s6", { 'tri-state-checkbox_disabled': _unref(forceDisabled) }])
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('portfolio.selectAll')), 1),
      _createVNode(_component_TriStateCheckbox, {
        modelValue: triStateCheckboxValue.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((triStateCheckboxValue).value = $event)),
          onTriStateCheckBoxUpdated
        ],
        disabled: _unref(triStateCheckboxDisabled)
      }, null, 8, ["modelValue", "disabled"])
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(state).layout.isDesktop ? 'panel-scrollable-content' : '')
      }, [
        (!_unref(forceDisabled))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(draggable), {
                  class: "dragArea draggable-list gutter-y-s1 w-full",
                  list: _unref(draggableTokensListMutable),
                  disabled: _unref(draggableTokensList).length < 2,
                  onChange: onSetTokenOrder,
                  "ghost-class": "draggable-placeholder",
                  "drag-class": "draggable-drag",
                  animation: 250,
                  handle: ".drag-icon",
                  "force-fallback": "true"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_TransitionGroup, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(draggableTokensList), (token) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex align-items-center",
                            key: token.address
                          }, [
                            _hoisted_5,
                            _createVNode(Token, {
                              class: "draggable-list-item",
                              address: token.address,
                              currentAction: props.currentAction,
                              draggable: ""
                            }, null, 8, ["address", "currentAction"])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["list", "disabled"])
              ]),
              (_unref(checkedAndNotDraggableTokenList).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkedAndNotDraggableTokenList), (token) => {
                      return (_openBlock(), _createBlock(Token, {
                        key: token.address,
                        address: token.address,
                        currentAction: props.currentAction
                      }, null, 8, ["address", "currentAction"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_unref(activeAndNotCheckedTokensList).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeAndNotCheckedTokensList), (token) => {
                      return (_openBlock(), _createBlock(Token, {
                        key: token.address,
                        address: token.address,
                        currentAction: props.currentAction
                      }, null, 8, ["address", "currentAction"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (
              _unref(disabledTokensList).length || _unref(unavailableTokensList).length || _unref(blockedTokensList).length
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_Transition, { name: "toggleable-content" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(disabledTokensList), (token) => {
                            return (_openBlock(), _createBlock(Token, {
                              key: token.address,
                              address: token.address,
                              currentAction: props.currentAction,
                              forceDisables: ""
                            }, null, 8, ["address", "currentAction"]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blockedTokensList), (token) => {
                            return (_openBlock(), _createBlock(TokenUnavailable, {
                              key: token.tokenAddress,
                              "notice-type": _unref(blockedTokenNoticeType),
                              "token-info": token,
                              action: _unref(easyModeForm).action
                            }, null, 8, ["notice-type", "token-info", "action"]))
                          }), 128)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unavailableTokensList), (token) => {
                            return (_openBlock(), _createBlock(TokenUnavailable, {
                              key: token.tokenAddress,
                              "token-info": token,
                              "notice-type": _unref(TOKEN_NOTICE_TYPES).NOT_AVAILABLE,
                              action: _unref(easyModeForm).action
                            }, null, 8, ["token-info", "notice-type", "action"]))
                          }), 128))
                        ], 512), [
                          [_vShow, !isCollapsed.value || _unref(state).layout.isDesktop]
                        ])
                      ]),
                      _: 1
                    }),
                    (!_unref(state).layout.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_Button, {
                            class: "button-plain mt-s3",
                            onClick: toggleCollapsed,
                            label: 
                  isCollapsed.value
                    ? _ctx.$t('portfolio.showUnavailableTokens')
                    : _ctx.$t('portfolio.hideUnavailableTokens')
                ,
                            icon: isCollapsed.value ? 'pi pi-chevron-down' : 'pi pi-chevron-up',
                            "icon-pos": "right"
                          }, null, 8, ["label", "icon"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(easyModeForm).tokens, (token) => {
                  return (_openBlock(), _createBlock(Token, {
                    key: token.address,
                    address: token.address,
                    currentAction: props.currentAction,
                    forceDisables: ""
                  }, null, 8, ["address", "currentAction"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blockedTokensList), (token) => {
                  return (_openBlock(), _createBlock(TokenUnavailable, {
                    key: token.tokenAddress,
                    "notice-type": _unref(blockedTokenNoticeType),
                    "token-info": token,
                    action: _unref(easyModeForm).action
                  }, null, 8, ["notice-type", "token-info", "action"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(unavailableTokensList), (token) => {
                  return (_openBlock(), _createBlock(TokenUnavailable, {
                    key: token.tokenAddress,
                    "token-info": token,
                    "notice-type": _unref(TOKEN_NOTICE_TYPES).NOT_AVAILABLE,
                    action: _unref(easyModeForm).action
                  }, null, 8, ["token-info", "notice-type", "action"]))
                }), 128))
              ])
            ]))
      ], 2)
    ])
  ]))
}
}

})